module.exports = __webpack_public_path__ + "officialStatic/img/product-ap.d2e5f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-ap.png
// module id = Jlu2
// module chunks = 0